<template>
  <AppWithLoading v-slot:default="{loader}">
    <VacanciesListDetail>
      <template #head>
        <h1 class="qr-title">
          {{ $t('h1') }}
        </h1>
      </template>
      <template v-slot:actions="{item, validate}">
        <VBtn
          color="success"
          dark
          elevation="0"
          class="mt-2 mb-5 mr-3"
          type="submit"
          @click="loader(()=>validate() && store(item))"
        >
          {{ $t('add') }}
        </VBtn>
        <VBtn
          color="default"
          outlined
          elevation="0"
          class="mt-2 mb-5"
          @click="$router.replace({name: 'qr-list'})"
        >
          {{ $t('cancel') }}
        </VBtn>
      </template>
    </VacanciesListDetail>
  </AppWithLoading>
</template>

<script>
import useVacanciesList from '@/compositions/useVacanciesList';
import VacanciesListDetail from '@/components/VacancyLists/VacanciesListDetail';
import AppWithLoading from '@/components/AppWithLoading';

export default {
  name: 'VacanciesListDetailAddPage',
  components: { AppWithLoading, VacanciesListDetail },
  setup(_, { root: { $router } }) {
    const { store } = useVacanciesList();

    function toList() {
      $router.push({ name: 'qr-list' });
    }

    return {
      store: async (item) => {
        await store(item);
        toList();
      },
    };
  },
};
</script>

<style scoped>
.qr-title {
  font-size: 1.5rem;
  line-height: 1.25;
  font-weight: 400;
  color: #212121;
  padding-top: 1.75rem;
  margin-bottom: 1.375rem;
}
</style>

<i18n lang="yml" locale="ru">
add: Создать подборку вакансий
h1: Новая подборка вакансий
cancel: Отмена
</i18n>
<i18n lang="yml" locale="en">
add: Create jobs selection
h1: New jobs selection
cancel: Cancel
</i18n>
